import { useEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

// Global scroll restoration: every PUSH navigation to a new route starts at the top.
// Back/Forward (POP) keeps the browser's remembered position, and in-page anchor
// links (#section) are left untouched.
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();
  const navType = useNavigationType();

  useEffect(() => {
    if (hash) return;
    if (navType === "POP") return;
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname, hash, navType]);

  return null;
}
